var React = require('react');
var Modal = require('react-bootstrap').Modal;
var Button = require('react-bootstrap').Button;
var ButtonLink = require('react-router-bootstrap').ButtonLink;
var Access = require('./Access');
var cx = require('classnames');

var Loading = require('../Loading');
var ServiceActions = require('../../actions/ServiceActions');
var ClientServiceStore = require('../../stores/ClientServiceStore');
var ClientStore = require('../../stores/ClientStore');
var ContactStore = require('../../stores/ContactStore');
var UserStore = require('../../stores/UserStore');
var AccessSelector = require('./AccessSelector');
var Invocation = require('../../api/Invocation');

function getState(props) {
  const client = ClientStore.get()
  const invites = (client ? client.relationshipInvites : []) || []
  const id = parseInt(props.params.id, 10)

  return {
    client,
    invite: invites.find(invite => invite.id === id),
    loading: ContactStore.loading() || ClientStore.loading(),
    working: ContactStore._working,
  }
}

var AccessInvite = React.createClass({
  contextTypes: {
    router: React.PropTypes.func
  },
  componentDidMount: function() {
    ClientStore.addChangeListener(this.update);
    ContactStore.addChangeListener(this.update);
    UserStore.addChangeListener(this.update);
  },
  componentWillMount: function () {
    this.update()

    var user = UserStore.getUser();

    if (user && !ClientServiceStore.has() && !ClientServiceStore.loading()) {
      ServiceActions.getServices(user);
    }
  },
  componentWillUnmount: function () {
    ClientStore.removeChangeListener(this.update);
    ContactStore.removeChangeListener(this.update);
    UserStore.removeChangeListener(this.update);
  },
  handleDeauth: function () {
    const replaceWith = UserStore.getUser().email

    Invocation.auth
      .deauth(this.state.invite.client_id, this.state.invite.email || this.state.invite.user.email, replaceWith)
      .then(() => this.context.router.transitionTo('access'))
  },
  updateInvite: function (e) {
    e.preventDefault()

    Invocation.auth
      .auth(
        this.state.invite.client_id,
        this.state.invite.email || this.state.invite.user.email,
        this.refs.roleSelector.getRoles(),
        this.state.invite.first_name,
        this.state.invite.last_name,
        this.state.invite.contact_number
      )
      .then(() => this.context.router.transitionTo('access'))
  },
  update: function () {
    this.setState(getState(this.props))
  },
  getInitialState: function () {
    return {
      errors: null,
      working: null,
    }
  },
  render: function () {
    return (
      <div>
        <Access />

        <Modal
          animation={false}
          onHide={() => this.context.router.transitionTo('access')}
          show
        >
          <form onSubmit={this.updateInvite}>
            <div className="modal-header">
              <h4>Manage Authorisation Invite for {this.state.invite ? (this.state.invite.first_name + ' ' + this.state.invite.last_name) : <Loading />}</h4>
            </div>
            <div className="modal-body">
              {this.state.invite
                ? <AccessSelector
                    ref="roleSelector"
                    roles={this.state.invite.roles}
                    showRoles={this.state.client && !!this.state.client.partner}
                  />
                : <Loading />
              }
            </div>
            <div className="modal-footer">
              <Button className="pull-left" bsStyle="danger" onClick={this.handleDeauth}>
                {this.state.working === 'DEAUTH' && (
                  <span><i className="fa fa-spinner fa-spin"></i> </span>
                )}
                Cancel Invite
              </Button>
              <ButtonLink to="access">Close</ButtonLink>
              <Button to="access" bsStyle="success" type="submit">
                {this.state.working === 'AUTH' && (
                  <span><i className="fa fa-spinner fa-spin"></i> </span>
                )}
                Save
              </Button>
            </div>
          </form>
        </Modal>
      </div>
    );
  }
})
module.exports = AccessInvite;



// WEBPACK FOOTER //
// ./app/components/Access/AccessInvite.js